import { useRef, useState } from "react";
import { useDispatch } from 'react-redux';
import { getHoldingReport} from '../../../actions/hpmAction';
import { getUserPreference } from "../../../utilities/common";
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    total: {
        display: 'flex',
        flexDirection: 'column'
    },
    root: {
        display: 'flex',
        width: '100%',
        alignItems: 'center'
    },
    container: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        marginTop: 20
    },
    textFieldStyle: {
        width: '60%',
        marginRight: 10
    },
    buttonStyle: {
        width: '30%'
    }
}));

function GetHoldingReport(props) {
    const classes = useStyles();
    const {t} = useTranslation('holdingPackagesManagement');
    const dispatch = useDispatch();
    const timer = useRef();
    let userPref = getUserPreference();

    const [blockBatch, setBlockBatch] = useState('');
    const [disable, setDisable] = useState(false);

    const handleBlockBatchInput = (event) => {
        setBlockBatch(event.target.value);
        props.handleBlockBatch(event.target.value);
    };

    return (
        <div className={classes.total}>
            <div className={classes.root}>
                <TextField
                    placeholder={t('input_block_batch')}
                    onChange={handleBlockBatchInput}
                    rows={10}
                    variant="outlined"
                    className={classes.textFieldStyle}
                />
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleGetHoldingReport}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('search')}
                </Button>
            </div>
            {
                localStorage.getItem("blockBatch") && <div className={classes.root}>
                    <Grid 
                        container 
                        alignItems="center"
                        justify="center"
                        className={classes.container}
                    >
                        <Grid item xs={3} style={{padding: 16}}>
                            <div>{t('refresh_countdown')}</div>
                        </Grid>
                        <Grid item xs={3} style={{padding: 16}}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => handleRefresh(3)}
                                style={{ width: '100%' }}
                                disabled={disable}
                            >
                                {t('three_minutes')}
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{padding: 16}}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => handleRefresh(5)}
                                style={{ width: '100%' }}
                                disabled={disable}
                            >
                                {t('five_minutes')}
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{padding: 16}}>
                            <Button 
                                variant="contained" 
                                color="primary" 
                                onClick={() => handleRefresh(10)}
                                style={{ width: '100%' }}
                                disabled={disable}
                            >
                                {t('ten_minutes')}
                            </Button>
                        </Grid>
                    </Grid>               
                </div>
            }
        </div>
    );

    function handleGetHoldingReport() {
        localStorage.setItem("blockBatch", blockBatch);
        dispatch(getHoldingReport(userPref.userCity, blockBatch, 0))
        .then((res) => {
            props.handleReport(res.report);
            props.handleSummary(res.summary);
        })
    }
    function handleRefresh(time) {
        setDisable(true);
        const countdown = time * 60000;
        const blockBatchCurr = localStorage.getItem("blockBatch");
        timer.current = window.setTimeout(() => {
            dispatch(getHoldingReport(userPref.userCity, blockBatchCurr, 0))
            .then((res) => {
                props.handleReport(res.report);
                props.handleSummary(res.summary);
                setDisable(false);
            })
        }, countdown);
    }
}

export default GetHoldingReport;